<template>
    <div class="login-content">
        <div class="login-content-title">邮箱绑定</div>
        <p class="login-content-tip">
            为了保护您的账号安全，请验证身份，验证成功后进行下一步操作
        </p>
        <el-form :model="login" :rules="loginRules" ref="loginForm" name="login" key="login">
            <el-form-item prop="email" class="login-form__item">
                <el-input
                    type="text"
                    name="email"
                    key="login-email-input"
                    placeholder="邮箱账号"
                    v-model="login.email"
                />
            </el-form-item>
            <el-form-item prop="password" class="login-form__item">
                <el-input
                    type="password"
                    name="password"
                    key="login-password-input"
                    placeholder="密码"
                    show-password
                    v-model="login.password"
                    @keyup.native.enter="handleLogin"
                />
            </el-form-item>
            <el-button
                type="primary"
                class="login__button"
                :loading="loginBtnLoading"
                @click="handleLogin"
            >绑定</el-button>
        </el-form>
        <div class="forget-password__button">
            <router-link tag="span" :to="{ name: 'Register' }">没有账号？点此注册</router-link>
            <router-link tag="span" :to="{ name: 'ForgetPassword' }">忘记密码</router-link>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';

    export default {
        name: 'Login',
        data() {
            return {
                login: {
                    email: '',
                    password: ''
                },
                loginRules: {
                    email: [
                        { required: true, message: '请输入国内邮箱', trigger: 'blur' },
                        { type: 'email', message: '请输入正确的国内邮箱地址', trigger: ['blur', 'change'] }
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' }
                    ]
                },
                loginBtnLoading: false
            };
        },
        methods: {
            ...mapActions('user', ['WxBinding']),
            handleLogin() {
                this.$refs.loginForm.validate(valid => {
                    if (valid) {
                        const params = {
                            ...this.login,
                            openid: sessionStorage.getItem('openId'),
                            nickname: sessionStorage.getItem('nickName')
                        };
                        this.loginBtnLoading = true;
                        this.WxBinding(params).then(res => {
                            if (res.code === 0) {
                                let path = localStorage.getItem('path');
                                this.$router.push({path});
                                this.$message.success('绑定成功');
                                this.$store.dispatch('user/getUserInfo');
                            }
                        }).finally(() => {
                            this.loginBtnLoading = false;
                        });
                    }
                });
            },
        }
    };
</script>

<style lang="scss" scoped>
.login-content {
    &-title {
        @include font(#333, 20px, 600);
    }
    &-title--warning {
        margin-bottom: 40px;
        @include font(rgba(247, 101, 84, 1), 20px, 600);
    }
    &-tip{
        margin-bottom: 40px;
        font-size: 14px;
        color: #aaa;
    }

    .login-form__item {
        margin-bottom: 32px;
    }
    .login__button {
        width: 100%;
    }

    .forget-password__button {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        text-align: right;
        @include font(rgba(145, 145, 145, 1), 16px, 400);
        span {
            cursor: pointer;
            &:first-child{
                text-decoration: underline;
                @include font(rgba(47, 84, 235, 1), 16px, 400);
            }
        }
    }
}
</style>
